import React, { useState } from "react";
import { Button, Flex } from "antd";
import { EditOutlined } from "@ant-design/icons";

import DSDCard from "./DSDCard";
import DSDEditModal from "./DSDEditModal";

import useRoleCheck from "utilities/hooks/roleCheck";

const DSDs = ({ division, onChange }) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const { hasPermission } = useRoleCheck();

  return (
    <Flex align="center">
      <DSDCard dsd={division.dsd} />
      {hasPermission(["Admin.Manage"], [], null, false) && (
        <Button
          type="text"
          icon={<EditOutlined />}
          onClick={() => setEditModalOpen(true)}
        />
      )}
      <DSDEditModal
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        division={division}
        onChange={onChange}
      />
    </Flex>
  );
};

export default DSDs;
